import React, { useContext } from 'react'
import {
    StyledActionsContent,
    StyledActionGroup,
    StyledWestHeaderItem,
} from './TheWestHeaderActions.styled'
import { RenderTargetContext } from '@news-mono/web-common'
import { MenuAction, MenuActionProps } from './MenuAction'
import { MastHeadLogo } from '../../content/TheWestHeader/logos/MastheadLogo'

export interface TheWestActionsStructureProps extends MenuActionProps {
    onEvent: (event: any) => void
}

export const TheWestActionsStructure: React.FC<{
    left: React.ReactElement
    center: React.ReactElement
    right: React.ReactElement | false
}> = ({ left, right, center }) => {
    return (
        <StyledActionsContent>
            {left}
            {center}
            {<StyledActionGroup>{right && right}</StyledActionGroup>}
        </StyledActionsContent>
    )
}

export const TheWestHeaderActionsApp: React.FC<TheWestActionsStructureProps> = ({
    onEvent,
    ...menuActionProps
}) => {
    const renderTarget = useContext(RenderTargetContext)

    return (
        <TheWestActionsStructure
            left={
                <StyledWestHeaderItem>
                    {renderTarget.renderTarget !== 'static-error-page' && (
                        <MenuAction {...menuActionProps} />
                    )}
                </StyledWestHeaderItem>
            }
            center={<MastHeadLogo height={28} />}
            right={false}
        />
    )
}
TheWestHeaderActionsApp.displayName = 'TheWestHeaderActionsApp'
